module.exports = __webpack_public_path__ + "img/personal.6e6d7911.svg";